export default {
  ru: {
    faq: 'Часто задаваемые вопросы',
    events: 'Расписание мероприятий',
    tickets: 'Купить билет',
    selfie: 'Селфи с роботом',
    entertainment: 'Развлечения',
    feedback: 'Оставить отзыв',
    rate: 'Оцените работу музея',
    fetchPending: 'Загрузка.<br>Пожалуйста, подождите ...',
  },
  en: {
    // en
  },
};
